function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Ship = function Ship(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    d: "M20 3.25a.75.75 0 0 1 .75.75v1.25h.75a.75.75 0 0 1 0 1.5h-5.648l-1.25 1.5H21.5a.75.75 0 0 1 0 1.5H10.841l-2.673 3.054L10.7 14.25h10.8a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.372-.099L6.801 13.75H4.264l2.394 4.39.013.027a2.7 2.7 0 0 1 1.587.815 1.22 1.22 0 0 0 1.77 0 2.723 2.723 0 0 1 3.944 0 1.22 1.22 0 0 0 1.77 0 2.723 2.723 0 0 1 3.944 0c.482.506 1.29.506 1.771 0a.75.75 0 0 1 1.086 1.036 2.723 2.723 0 0 1-3.943 0 1.22 1.22 0 0 0-1.77 0 2.723 2.723 0 0 1-3.944 0 1.223 1.223 0 0 0-1.771 0 2.723 2.723 0 0 1-3.944 0 1.22 1.22 0 0 0-1.77 0 2.723 2.723 0 0 1-3.841.101l-.103-.101-.05-.059a.75.75 0 0 1 1.136-.977c.482.506 1.29.506 1.772 0 .232-.243.498-.432.783-.57L2.342 13.36A.75.75 0 0 1 3 12.25h3.66l3.276-3.744a.75.75 0 0 1 .564-.256h2.149l2.275-2.73a.75.75 0 0 1 .576-.27h1.25V4a.75.75 0 0 1 1.5 0v1.25h1V4a.75.75 0 0 1 .75-.75m-7.5 8a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1 0-1.5zm4 0a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1 0-1.5zm4 0a.75.75 0 0 1 0 1.5H20a.75.75 0 0 1 0-1.5z"
  }));
};
export default Ship;
Ship.displayName = 'Ship';